<template>
  <div>
    <Button
      :size="15"
      color="#28a745"
      colorText="#ffffff"
      tooltip="Importar"
      icon="fas fa-plus"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      traslate
      title="Agregar sección"
      @click.native="openModal('modal')"
    />

    <ui-modal ref="modal" size="large" title="Agregar Nueva Sub Sección">
      <!-- <pre>{{ listaModulos }}</pre>
      <pre>{{ listaSecciones }}</pre> -->

      <!-- row 1 -->
      <div class="d-flex">
        <ui-textbox
          floating-label
          label="Nombre"
          v-model="nombreModel"
          class="w-50 mr-3"
        />

        <ui-textbox
          floating-label
          label="Referencia"
          v-model="referenciaModel"
          class="w-50"
        />
      </div>

      <!-- row 2 -->
      <div class="d-flex">
        <ui-select
          class="w-50 mr-3"
          has-search
          label="Modulos"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="listaModulos"
          v-model="modulesModel"
          @change="filtrarSecciones(modulesModel)"
        />

        <ui-select
          class="w-50"
          has-search
          label="Sección"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="listaSeccionesAux"
          v-model="seccionesModel"
        />
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-primary" @click="crearSubSeccion">
          Guardar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";

// Buttom
import Button from "../../../common/Button";

// Constantes
import {
  saveSubSeccion,
  getSubSecciones,
} from "../../../../constants/superadministrador";

export default {
  props: ["listaSecciones", "listaModulos"],

  data() {
    return {
      nombreModel: "",
      referenciaModel: "",
      modulesModel: [],
      seccionesModel: [],
      listaSeccionesAux: [],
    };
  },
  components: {
    UiModal,
    UiTextbox,
    UiSelect,
    Button,
  },
  methods: {
    ...mapActions("superadministrador", ["actionSetDataSubSecciones"]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    filtrarSecciones(item) {
      this.seccionesModel = [];

      let secciones = this.listaSecciones.filter((seccion) => {
        return item.id == seccion.id_module;
      });

      this.listaSeccionesAux = secciones;

      secciones.length && (this.seccionesModel = secciones[0]);
    },

    async crearSubSeccion() {
      let data = {
        name: this.nombreModel,
        id_parent: this.seccionesModel.id,
        name_reference: this.referenciaModel,
        id_module: this.modulesModel.id,
      };

      let sql = await saveSubSeccion(data);

      if (sql.data == 200) {
        this.$vToastify.success("Sección agregada con éxito", "¡Realizado!");

        this.nombreModel = "";
        this.referenciaModel = "";
        this.modulesModel = [];
        this.seccionesModel = [];

        let dataSubSeccionesDB = await getSubSecciones();
        this.data = dataSubSeccionesDB;

        this.actionSetDataSubSecciones(dataSubSeccionesDB.data_table);
      } else {
        this.$vToastify.error("Error al crear sección", "¡Error!");
      }

      this.closeModal("modal");
    },
  },
};
</script>

<style></style>
